import clsx from 'clsx';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "hint": "pbui-CKrO2",
  "hint--no-error": "pbui-6kIUW",
  "hint--has-error": "pbui-G2pXE",
  "label": "pbui-Kunxd",
  "container": "pbui-Ut6eR",
  "input__container": "pbui-PM4KV",
  "input__container--disabled": "pbui-9PoPD",
  "input__container--has-error": "pbui-bkbDX",
  "input": "pbui-x7tmo",
  "prefix": "pbui-bEYBP",
  "suffix": "pbui-9cutn",
  "prefix--with-divider": "pbui-AA6VK",
  "suffix--with-divider": "pbui-126C-",
  "input__container--focus-orange": "pbui-c0Lfj"
};
export var InputHint = function InputHint(_ref) {
  var children = _ref.children,
    hasError = _ref.hasError;
  var hintClasses = clsx(styles.hint, hasError ? styles['hint--has-error'] : styles['hint--no-error']);
  return /*#__PURE__*/_jsx("div", {
    className: hintClasses,
    children: children
  });
};